// https://vitejs.dev/config/#build-polyfillmodulepreload
import 'vite/modulepreload-polyfill'

import './assets/scss/reset.scss'
import './assets/scss/fonts.scss'
import './assets/scss/cssVars.scss'
import './assets/scss/default.scss'
import './assets/scss/defaultText.scss'
import './assets/scss/layoutDefault.scss'
import './assets/scss/fancybox.scss'
import './assets/scss/print.scss'

import { Fancybox } from '@fancyapps/ui/dist/fancybox/'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

Fancybox.bind('[data-fancybox]', {
  Carousel: {
    Thumbs: false,
    Toolbar: {
      items: {
        close: {
          tpl: '<button data-fancybox-close class="f-button ddd is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" style="stroke-width: 0;" viewBox="0 0 24 24" tabindex="-1"><path d="M24 2.97331L14.9733 12L24 21.0267L21.0267 24L12 14.9733L2.97331 24L0 21.0267L9.02669 12L0 2.97331L2.97331 0L12 9.02669L21.0267 0L24 2.97331Z" fill="currentColor" stroke="0"/></svg></button>',
        },
      },
      display: {
        left: [],
        middle: [],
        right: ['close'],
      },
    },
    Zoomable: {
      Panzoom: {
        maxScale: 'cover',
        panMode: 'mousemove',
        mouseMoveFactor: 1.1,
      },
    },
    Arrows: {
      prevTpl:
        '<button data-carousel-go-prev tabindex="0" class="f-button is-arrow is-prev" title="{{PREV}}"><svg class="Slideshow-buttonIcon icon icon--filled" aria-hidden="true"><use href="#previous"></use></svg></button>',
      nextTpl:
        '<button data-carousel-go-next tabindex="0" class="f-button is-arrow is-next" title="{{NEXT}}"><svg class="Slideshow-buttonIcon icon icon--filled" aria-hidden="true"><use href="#next"></use></svg></button>',
    },
  },
  l10n: {
    PREV: 'Vorheriges Bild',
    NEXT: 'Nächstes Bild',
  },
})

if (import.meta.hot) {
  import.meta.hot.accept()
}

import.meta.glob('./modules/**/*.scss', { eager: true })
import.meta.glob('./modules/**/*.js', { eager: true })

import sprite from 'virtual:icon-sprite'
document.body.insertAdjacentHTML('beforeend', sprite)

document.querySelectorAll('[loading="lazy"]').forEach((element) => {
  const animateIn = () => {
    element.style.opacity = 1
  }

  if (element.complete) {
    animateIn()
  } else {
    element.addEventListener('load', animateIn)
  }
})
